import { Stack } from '@mui/material';
import React from 'react'
import CouponRadioField from './CouponRadioField';
import CouponConfigurableLabel from '../CouponConfigurableLabel';

/**
 * This component is a general component which is a radio selector
 * Options : List of option of radio selector fileds 
 * direction : direction of options
 * selectedValue : selected option
 * handleChange : this function gets executed when there any selection is done in radio field
 * @param props 
 * @returns 
 */

function CouponRadioSelector(props:any) {
    const {options , selectedValue , handleChange, direction="row"} = props;
  return (
      <div className="Coupon-radio-selector-wrapper">
          <Stack direction={direction} gap={'30px'} justifyContent={"flex-start"} flexWrap={'wrap'}>
              {
                  options.map((option: { value: string, description?: string }) => {
                      const checked = option.value === selectedValue;
                      return <CouponRadioField
                          key={option.value}
                          label={<CouponConfigurableLabel text={option.value} style={{ cursor: 'inherit', color: 'inherit' }} />} value={option.value} description={option.description} checked={checked}
                          handleChange={handleChange} />
                  })
              }
          </Stack >
      </div>
  )
}

export default CouponRadioSelector